import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DEV_BASE_URL, PROD_BASE_URL } from '../services/api.url';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // N'ajoute le header que pour les appels vers l'IrisApi (dev ou prod)
    const url = request.url;
    if (url.startsWith(DEV_BASE_URL) || url.startsWith(PROD_BASE_URL)) {
      request = request.clone({
        setHeaders: { 'X-Iris-Key': environment.irisApiKey }
      });
    }
    return next.handle(request);
  }
}
